(function (angular) {
	'use strict';

	angular
		.module('loginCaptchaModule')
		.controller('LoginCaptchaController', [
			'mixpanelFactory',
			'urlFactory',
			'vcRecaptchaService',
			LoginCaptchaControllerFunction
		]);

	function LoginCaptchaControllerFunction(
		mixpanelFactory,
		urlFactory,
		vcRecaptchaService
	) {	
		var loginCaptcha = this;
		var widgetId;

		loginCaptcha.initRecaptcha = function(){
			vcRecaptchaService.execute(widgetId);
		};

		loginCaptcha.resetRecaptcha = function(){
			vcRecaptchaService.reload(widgetId);
			loginCaptcha.formSubmitted = false;
		};

		loginCaptcha.setWidgetId = function(id){
			widgetId = id;
		};

		loginCaptcha.successfulRecaptcha = function() {
			loginCaptcha.recaptchaResponse = vcRecaptchaService.getResponse(widgetId);
			loginCaptcha.formSubmitted = true;
			urlFactory.submitFormById('loginCaptchaForm');
		};

		loginCaptcha.$onInit = function() {
			mixpanelFactory.track('Login Captcha Shown');
		};
	}
})(window.angular);